import {css} from '@emotion/react'
import {useAiContext} from './AiContext.mjs'

const cssTools = css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
})

const cssSection = css({
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    overflow: 'hidden',
})

const cssSectionCompact = css({
    gap: 4,
})

export const DraftTools = ({tools: [left, right] = [], ...props}) => {
    const ai = useAiContext()

    return (
        <div
            css={cssTools}
            {...props}
        >
            <div css={[cssSection, ai.compactView && cssSectionCompact]}>
                {left}
            </div>

            <div css={[cssSection, ai.compactView && cssSectionCompact]}>
                {right}
            </div>
        </div>
    )
}
